import { AutocompleteInputChangeReason } from "@mui/material";
import { BackPageButtonSearchParamName } from "components/buttons/BackPageButton/types";
import AutocompleteControl from "components/form/AutocompleteControl";
import ROUTES from "constants/routes";
import typography from "constants/typography.constants";
import qs from "qs";
import { useFormContext } from "react-hook-form";
import { useParams } from "react-router-dom";
import { CompetencyMapInputs, CompetencyMapOption, CompetencyMapOptionList, ICompetencyMapOption } from "../types";

interface CompetencyMapControlProps {
  isEditing: boolean;
  competencyMapsLoading: boolean;
  competencyMaps: CompetencyMapOptionList;
  type: "trial" | "examination";
}

const CompetencyMapControl = ({
  isEditing,
  competencyMapsLoading,
  competencyMaps,
  type,
}: CompetencyMapControlProps) => {
  const { id: examinationOrTrialId } = useParams();
  const { setValue, reset, getValues, watch } = useFormContext<CompetencyMapInputs>();
  const onCompetencyMapChange = (data: CompetencyMapOption | ICompetencyMapOption | null) => {
    if (data && typeof data === "object" && "comment" in data) {
      setValue("competencyMapComment", data.comment || "");
      setValue("competencyMapGrades", data?.grades?.join(", ") || "");
    }
    return data ? { id: data.id, title: data.title } : data;
  };

  const resetCompetencyMapFields = () => {
    reset({
      ...getValues(),
      competencyMap: undefined,
      competencyMapComment: "",
      competencyMapGrades: "",
    });
  };

  const onAutocompleteInputChange = (reason: AutocompleteInputChangeReason) => {
    if (reason === "clear") {
      resetCompetencyMapFields();
    }
  };

  const { id: competencyMapId } = watch("competencyMap") || {};

  return (
    <AutocompleteControl<CompetencyMapOption, false, false, false, ICompetencyMapOption>
      options={competencyMaps || []}
      name='competencyMap'
      optionName='title'
      label='Карта компетенций'
      labelLink={
        competencyMapId
          ? {
              to: {
                pathname: `/${ROUTES.COMPETENCE_MAPS}/view/${competencyMapId}`,
                search: qs.stringify({
                  [type === "examination"
                    ? BackPageButtonSearchParamName.EXAMINATION_ID
                    : BackPageButtonSearchParamName.TRIAL_ID]: examinationOrTrialId,
                }),
              },
              text: typography.follow,
            }
          : undefined
      }
      disabled={!isEditing}
      loading={competencyMapsLoading}
      rules={{ required: true }}
      formatDataBeforeOnChange={onCompetencyMapChange}
      onInputChange={(_, inputValue, reason) => onAutocompleteInputChange(reason)}
    />
  );
};

export default CompetencyMapControl;
